import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from '../../Wrapper.js';
var _excluded = ["additionalClasses", "type"];
var CardsWrapper = function CardsWrapper(_ref) {
  var _ref$additionalClasse = _ref.additionalClasses,
    additionalClasses = _ref$additionalClasse === void 0 ? '' : _ref$additionalClasse,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    className: "cards-wrapper ".concat(type, "-cards-wrapper ").concat(additionalClasses)
  }));
};
CardsWrapper.displayName = "CardsWrapper";
CardsWrapper.propTypes = {
  additionalClasses: PropTypes.string,
  type: PropTypes.oneOf(['narrow', 'wide'])
};
export { CardsWrapper };